import { Component, ComponentFactoryResolver, Input, ViewChild, OnInit, ViewContainerRef } from "@angular/core";

import { ModuleSectionDirective } from './module-section.directive';

import { ModuleComponent } from './module.component';
import { IGuide } from "../models/guide";


@Component({
  selector: 'module-section',
  template: `                            
              <ng-template module-host></ng-template>              
            `
})
export class ModuleSectionComponent implements OnInit {

  private _moduleComponent: any;


  @Input()
  module: string;

  @Input()
  activity: string;

  @Input()
  complete: string;

  get moduleComponent(): any {
    return this._moduleComponent;
  }

  @Input() set moduleComponent(val: any) {
    this._moduleComponent = val;

    this.loadComponent();    
  }


  @Input()
  guide: IGuide;

  @ViewChild(ModuleSectionDirective, { static: true}) moduleHost: ModuleSectionDirective;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit() {
    //console.log('Module Section Component NgOnInit')
    
  }

  loadComponent() {    

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this._moduleComponent);

    const viewContainerRef = this.moduleHost.viewContainerRef;

    viewContainerRef.clear();    
    //console.log('loadModule', this.module);
    //console.log('loadActivity', this.activity);
    
    const componentRef = viewContainerRef.createComponent(componentFactory);
    //(<ModuleComponent>componentRef.instance).data = this.guide;
    (<ModuleComponent>componentRef.instance).module = this.module;
    (<ModuleComponent>componentRef.instance).activity = this.activity;
    (<ModuleComponent>componentRef.instance).completed = this.complete;

  }
}
